<template>
  <div v-if="visible" class="notification-banner in-header">
    <svg
      class="banner-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
    >
      <g id="Layer_1-2">
        <path
          class="cls-1"
          d="M28,0C12.56,0,0,12.56,0,28,0,35.15,2.66,41.89,7.51,47.08L.29,54.29c-.29.29-.37.72-.22,1.09.15.37.52.62.92.62h27c15.44,0,28-12.56,28-28S43.44,0,28,0ZM28,54H3.41l6.2-6.2c.19-.19.29-.44.29-.71s-.11-.52-.29-.71c-4.91-4.9-7.62-11.43-7.62-18.38C2,13.66,13.66,2,28,2s26,11.66,26,26-11.66,26-26,26Z"
        />
        <path
          class="cls-1"
          d="M28,33.92c-2.17,0-3.97-1.7-4.09-3.87l-.64-10.91c-.06-1.13.34-2.24,1.12-3.06.78-.83,1.84-1.28,2.97-1.28h1.28c1.13,0,2.21.47,2.99,1.29.78.83,1.17,1.91,1.1,3.05l-.64,10.91c-.13,2.17-1.93,3.86-4.09,3.86ZM27.36,16.81c-.58,0-1.12.23-1.52.65-.4.43-.61.98-.57,1.57l.64,10.91c.06,1.11.98,1.98,2.09,1.98s2.02-.87,2.09-1.98l.64-10.91c.04-.58-.16-1.14-.56-1.56-.4-.43-.94-.66-1.53-.66h-1.28Z"
        />
        <path
          class="cls-1"
          d="M27.98,43.19c-2.01,0-3.65-1.64-3.65-3.65s1.64-3.65,3.65-3.65,3.65,1.64,3.65,3.65-1.64,3.65-3.65,3.65ZM27.98,37.89c-.91,0-1.65.74-1.65,1.65s.74,1.65,1.65,1.65,1.65-.74,1.65-1.65-.74-1.65-1.65-1.65Z"
        />
      </g>
    </svg>
    <div class="notification-banner-text">
      <p>
        The new EHCP module is now live! From today, you can begin using the
        updated audit criteria and enhanced features. Your existing EHCP data
        will remain accessible after you transition to the new version.
      </p>
      <p>
        Invision360 will work directly with your Local Authority coordinator to
        ensure all users have moved over by the new year. For further
        information, please contact your LA coordinator.
      </p>
    </div>
    <svg
      @click="markAsRead"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width="55"
      height="55"
      class="close"
    >
      <path
        d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'NotificationsBanner',

  data() {
    return {
      visible: JSON.parse(localStorage.getItem('markBannerAsRead') || 'true')
    }
  },
  methods: {
    markAsRead() {
      this.visible = false
      localStorage.setItem('markBannerAsRead', JSON.stringify(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-banner {
  background-color: rgb(244, 197, 24);
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;

  &-text {
    padding: 0.5rem;
    font-size: 0.75rem;
  }
}
.close {
  cursor: pointer;
}

.banner-icon {
  width: 35px;
}
.in-header {
  width: 45rem;
  padding: 0 1rem;
  gap: 1rem;
  height: 100%;
  margin: 0 1rem;
}
.under-header {
  padding: 0.5rem;
}
.under-header > div {
  display: flex;
  gap: 0.5rem;
}
.under-header #banner-icon {
  margin-right: 0.5rem;
  width: 26px;
}
.under-header #banner-icon path {
  stroke-width: 1;
  stroke: black;
}
</style>
